module.exports = __webpack_public_path__ + "img/gls_gbt5781_2000.prt.b9155f7a.jpg";